module.exports = __webpack_public_path__ + "img/sliders.201991bf.svg";